import { render, staticRenderFns } from "./Trombi.vue?vue&type=template&id=4ab71186&"
import script from "./Trombi.vue?vue&type=script&lang=ts&"
export * from "./Trombi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports